import * as React from 'react';
import { useEffect } from 'react';
import './_CardProperties.scss';
import { ICardPropertiesProps } from './types';
import { BOARD_DETAILS_ONLY_OWNER, CLASS_BOARD_DETAILS } from '../../../../constants';
import {
    BOARD_SECTION_CARD_PROPERTIES_DEFAULT, BOARD_SECTION_CARD_PROPERTIES_PREVIEW,
    BOARD_SECTION_CARD_PROPERTIES_PROPERTIES,
    BOARD_SECTION_CARD_PROPERTIES_REQUIRED,
    BOARD_SECTION_CARD_PROPERTIES_TEXT,
    BOARD_SECTION_CARD_UNUSED_PROPERTIES_HIDE,
    BOARD_SECTION_CARD_UNUSED_PROPERTIES_SHOW
} from '../../constants';
import { CardPropertyItem } from '../CardPropertyItem/CardPropertyItem';
import { HideButton } from '../../../../../../base/components/HideButton/HideButton';
import { EAsidePanelProperty } from '../../../../../asidePanel/components/AsidePanel/types';
import ReactHtmlParser from 'react-html-parser';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardProperties`) : null;

export function CardProperties ({
    areAllDefault,
    cardProperties,
    isAdmin,
    isDisallow,
    isReadonly,
    onDefaultToggle,
    onPreviewToggle,
    onShowBoardLimitSnackbarIfNeeded,
    onRequiredToggle,
    onDisallowClick
}: ICardPropertiesProps) {
    if (analyzeRender) analyzeRender.call(`CardProperties`);
    const className = CLASS_BOARD_DETAILS + '__card-properties';
    const classText = className + '-text';
    const classColumn = className + '-column';
    const classType = classColumn + '--type';

    const [isHide, setHide] = React.useState(true);
    const [elements, setElements] = React.useState(cardProperties);

    const onChange = (
        key: EAsidePanelProperty,
        onToggle: (key: EAsidePanelProperty, option?: string) => void,
        isDefault: boolean,
        isRequired?: boolean,
        option?: string
    ) => {
        const newElements = elements.map((element) => {
            if (
                (
                    element.key === EAsidePanelProperty.CARD_DUE_DATE ||
                    element.key === EAsidePanelProperty.CARD_START_DATE
                ) &&
                (
                    key === EAsidePanelProperty.CARD_DUE_DATE ||
                    key === EAsidePanelProperty.CARD_START_DATE
                )
            ) {
                return {
                    ...element,
                    isDefault: isDefault,
                    isRequired: isDefault ?
                        key === element.key ? isRequired : element.isRequired
                        : false
                }
            } else {
                return {
                    ...element,
                    isDefault: (option ? option === element.option : key === element.key) ? isDefault : element.isDefault,
                    isRequired: isRequired && (option ? option === element.option : key === element.key) ?
                        isDefault ? isRequired : false
                        : element.isRequired
                }
            }
        });
        setElements(newElements);

        onToggle(key, option);
    }

    useEffect(() => {
        const sortedProperties = cardProperties.sort((a, b) => {
            if (a.isDefault === b.isDefault) {
                return 0;
            }
            return a.isDefault ? -1 : 1;
        });
        const newElements = sortedProperties.filter((element) => {
            const { isDefault, isRequiredOnly, isViewOnPreview } = element;
            return !isHide || (
                isDefault ||
                isRequiredOnly ||
                isViewOnPreview
            );
        });
        setElements(newElements);
    }, [isHide]);

    return (
        <div className={className}>
            <div className={classText}>
                <div>{ReactHtmlParser(BOARD_SECTION_CARD_PROPERTIES_TEXT)}</div>
                {isReadonly && <p className={classText}>{BOARD_DETAILS_ONLY_OWNER}</p>}
            </div>
            <div className={className + '-items'}>
                <div className={className + '-columns'}>
                    <span className={`${classColumn} ${classColumn}--property`}>{BOARD_SECTION_CARD_PROPERTIES_PROPERTIES}</span>
                    <span className={`${classColumn} ${classType}`}>{BOARD_SECTION_CARD_PROPERTIES_DEFAULT}</span>
                    <span className={`${classColumn} ${classType}`}>{BOARD_SECTION_CARD_PROPERTIES_REQUIRED}</span>
                    <span className={`${classColumn} ${classType}`}>{BOARD_SECTION_CARD_PROPERTIES_PREVIEW}</span>
                </div>
                {
                    elements.map((property) => {
                        const {
                            key,
                            name,
                            isRequired,
                            isPreviewOnly,
                            isPreview,
                            isViewOnPreview,
                            isDefaultOnly,
                            isDefault,
                            option,
                            isRequiredOnly
                        } = property;

                        return <CardPropertyItem
                                key={option ? option : key}
                                propertyKey={key}
                                option={option}
                                name={name}
                                isAdmin={isAdmin}
                                isReadonly={isReadonly}
                                isRequired={isRequired}
                                isDefault={isDefault}
                                isDefaultOnly={isDefaultOnly}
                                isDisallow={isDisallow}
                                isPreviewOnly={isPreviewOnly}
                                isPreview={isPreview}
                                onShowBoardLimitSnackbarIfNeeded={onShowBoardLimitSnackbarIfNeeded}
                                isViewOnPreview={isViewOnPreview}
                                onDisallowClick={onDisallowClick}
                                onPreviewToggle={property => {
                                    onPreviewToggle(property, option);
                                    const idx = elements.findIndex(item => option ? item.option === option : item.key === property);
                                    if (idx > -1) {
                                        const newElements = [
                                            ...elements.slice(0, idx),
                                            {
                                                ...elements[idx],
                                                isViewOnPreview: !elements[idx].isViewOnPreview,
                                            },
                                            ...elements.slice(idx + 1),
                                        ]
                                        setElements(newElements);
                                    }
                                }}
                                onDefaultToggle={() => onChange(key as EAsidePanelProperty, onDefaultToggle, !isDefault, isRequired, option)}
                                onRequiredToggle={() => onChange(key as EAsidePanelProperty, onRequiredToggle, true, !isRequired, option)}
                                isRequiredOnly={isRequiredOnly}
                            />
                    })
                }
            </div>
            {!areAllDefault &&
                <HideButton
                    labels={[BOARD_SECTION_CARD_UNUSED_PROPERTIES_SHOW, BOARD_SECTION_CARD_UNUSED_PROPERTIES_HIDE]}
                    isHide={isHide}
                    onClick={() => setHide(!isHide)}
                />
            }
        </div>
    );
};
